import { AssessmentWithEntries, EvaluationType, FilterKeys, GroupType } from '@schooly/api';

export type AssessmentsArrangeBy = FilterKeys.Date | FilterKeys.Subject | FilterKeys.AreaOfLearning;

export const getArrangedAssessmentsEntries = (
  assessments: AssessmentWithEntries[],
  arrangeBy: AssessmentsArrangeBy,
) => {
  const groups = new Map<string, AssessmentWithEntries[]>();

  assessments.forEach((entry) => {
    let key: string;

    switch (arrangeBy) {
      case FilterKeys.Date:
      // biome-ignore lint/suspicious/useDefaultSwitchClauseLast: Legacy code
      default:
        key = entry.assessment_date;
        break;

      case FilterKeys.Subject:
        const group = entry.groups[0];
        if (group?.type === GroupType.TutorGroup) {
          key = 'tutor-group';
        } else if (group?.subject?.id) {
          key = group.subject.id;
        } else {
          key = 'no-subject';
        }
        break;

      case FilterKeys.AreaOfLearning:
        if (entry.evaluation_type === EvaluationType.TutorFeedback) {
          key = 'tutor-feedback';
        } else if (
          entry.evaluation_type === EvaluationType.AreaOfLearning &&
          entry.area_of_learning
        ) {
          key = entry.area_of_learning.id;
        } else {
          key = 'regular';
        }
        break;
    }

    if (!groups.has(key)) {
      groups.set(key, []);
    }
    groups.get(key)?.push(entry);
  });

  return Array.from(groups.entries());
};
